export const APP_VERSION = process.env.REACT_APP_VERSION;

/**
 * KEYCLOAK
 */
export const KEYCLOAK_URL = process.env.REACT_APP_KC_URL;
export const KEYCLOAK_REALM = process.env.REACT_APP_KC_REALM;
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KC_CLIENT_ID;

/**
 * ROLES
 */
export const ROLE_GENOME_ADMIN = "ADMIN_USER";
export const ROLE_CLINIC_USER = "CLINIC_USER";

export const ROLES_ADMIN = [ROLE_GENOME_ADMIN, ROLE_CLINIC_USER];
export const ROLES_ALL = [ROLE_GENOME_ADMIN, ROLE_CLINIC_USER];

/**
 * NOTIFICATION SEVERITY
 */
export const SEVERITY_SUCCESS = "success";
export const SEVERITY_INFO = "info";
export const SEVERITY_WARNING = "warning";
export const SEVERITY_ERROR = "error";

/**
 * I18N
 */
export const LANGUAGES = {
  ES: "es",
};

/**
 * KEYS
 */
export const KEY_ENTER = "Enter";

/**
 * ROUTES
 **/
export const ROUTES_PUBLIC = "/genome/";

export const SEARCH_OMIM = "searchOmim";
export const PATIENT = "patient";
export const PATIENTS = "patients";
export const FORBIDDEN = "notAllowed";

export const ROUTES_HOME = `${ROUTES_PUBLIC}`;
export const ROUTES_SEARCH_OMIM = `${ROUTES_PUBLIC}${SEARCH_OMIM}`;
export const ROUTES_PATIENT = `${ROUTES_PUBLIC}${PATIENT}`;
export const ROUTES_PATIENTS = `${ROUTES_PUBLIC}${PATIENTS}`;
export const ROUTES_FORBIDDEN = `${ROUTES_PUBLIC}${FORBIDDEN}`;

export const ROUTES_DEFAULT = "*";

/**
 * BACKEND API
 */
export const GENOME_API_BASE_URL = process.env.REACT_APP_GENOME_API_BASE_URL;
export const GENOME_API_CATEGORIES = GENOME_API_BASE_URL + "api-sistema-gen/v1/symptoms/categories";
export const GENOME_API_DISEASES = GENOME_API_BASE_URL + "api-sistema-gen/v1/diseases";
export const GENOME_API_DISEASE_DETAIL = GENOME_API_BASE_URL + "api-sistema-gen/v1/diseases/:disease_id";
export const GENOME_API_SYMPTOMS = GENOME_API_BASE_URL + "api-sistema-gen/v1/symptoms";
export const GENOME_API_PATIENT_RECORD = GENOME_API_BASE_URL + "api-sistema-gen/v1/records/:record_id";
export const GENOME_API_RECORD = GENOME_API_BASE_URL + "api-sistema-gen/v1/records";
export const GENOME_API_RECORD_SYMPTOMS = GENOME_API_BASE_URL + "api-sistema-gen/v1/records/:record_id/symptoms";
export const GENOME_API_RECORD_SYMPTOM =
  GENOME_API_BASE_URL + "api-sistema-gen/v1/records/:record_id/symptoms/:symptom_id";
export const GENOME_API_RECORD_BACKGROUNDS = GENOME_API_BASE_URL + "api-sistema-gen/v1/records/:record_id/backgrounds";
export const GENOME_API_RECORD_PATIENT_BACKGROUNDS =
  GENOME_API_BASE_URL + "api-sistema-gen/v1/records/:record_id/patient-backgrounds";
export const GENOME_API_RECORD_BACKGROUND =
  GENOME_API_BASE_URL + "api-sistema-gen/v1/records/:record_id/backgrounds/:background_id";
export const GENOME_API_RECORD_DISEASES = GENOME_API_BASE_URL + "api-sistema-gen/v1/records/:record_id/diseases";
export const GENOME_API_RECORD_DISEASE =
  GENOME_API_BASE_URL + "api-sistema-gen/v1/records/:record_id/diseases/:disease_id";
export const GENOME_API_DOWNLOAD_MANUAL = GENOME_API_BASE_URL + "api-sistema-gen/v1/resources/download_users_manual";
export const GENOME_API_PATIENT_BACKGROUNDS =
  GENOME_API_BASE_URL + "api-sistema-gen/v1/records/:record_id/patient-backgrounds";

/**
 * HTTP CODES
 */
export const HTTP_CODE_401 = 401;
export const HTTP_CODE_422 = 422;
export const HTTP_CODE_409 = 409;
export const HTTP_CODE_404 = 404;

export const DEFAULT_HTTP_TIMEOUT = 15000;

/**
 * CATEGORIES
 */
export const CATEGORIES_ALL = "All";

/**
 * PAGE SIZES
 */
export const SYMPTOMS_PAGE_SIZE = 7;
export const SYMPTOMS_PAGE_SIZE_LARGE = 9;
export const DISEASES_PAGE_SIZE = 7;
export const PATIENTS_PAGE_SIZE = 8;
export const DEFAULT_PAGE_SIZE = 5;

/**
 * PATIENT INFO
 */
export const GENDER_MALE = "male";
export const GENDER_FEMALE = "female";

export const PDF_FILE_TITLE = "Manual de uso Genomepleio - Sistema GEN";

/**
 * BREAKPOINTS
 */
export const BREAKPOINT_XS = 0;
export const BREAKPOINT_SM = 600;
export const BREAKPOINT_MD = 960;
export const IPAD_WIDTH = 768;

export const TABLE_HEIGHT = "52vh";
